<div class="panel panel-default col-sm-5" style="margin-left: 100px; display: none" id="settingsUserLockout">
  <div class="panel-heading">User Lockout</div>

    <div class="panel-body">

    <form class="form-horizontal">
      <div class="form-group">
        <label class="control-label col-sm-4">Maximum Login Attempts</label>
        <div class="col-sm-8"><input class="form-control" type="text" name="max_login_attempts" [(ngModel)]="max_login_attempts"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-4">Lockout Duration (m)</label>
        <div class="col-sm-8"><input class="form-control" type="text" name="locked_time" [(ngModel)]="locked_time"></div>
      </div>

        <div class="modal-footer">
          <button class="btn btn-primary" (click)="updateSettingsLockout()"><i class="fa fa-refresh" aria-hidden="true"></i> UPDATE</button>
        </div>

      </form>
  </div>
</div>
